import { EnumColor } from '@40seas/frontend/common/providers';
import { NotificationDefinitionStatus } from '@40seas/entities/notifications';

export const notificationDefinitionStatusMapping = {
    [NotificationDefinitionStatus.Active]: 'success',
    [NotificationDefinitionStatus.Inactive]: 'warning',
} as { [key in NotificationDefinitionStatus]: EnumColor };
